// Package Speed Mapping
// Maps package names to their download and upload speeds
export const packageSpeedMapping = {
  // Any Time Packages
  "Fiber Starter": {
    downloadSpeed: "100",
    uploadSpeed: "50",
  },
  
  // Trio Packages
  "Trio Vibe": {
    downloadSpeed: "300",
    uploadSpeed: "150",
  },
  "Trio Vibe Plus": {
    downloadSpeed: "300",
    uploadSpeed: "150",
  },
  "Trio Shine": {
    downloadSpeed: "300",
    uploadSpeed: "150",
  },
  
  // Unlimited Packages
  "Unlimited Home": {
    downloadSpeed: "100",
    uploadSpeed: "50",
  },
  "Unlimited Home Plus": {
    downloadSpeed: "200",
    uploadSpeed: "100",
  },
  "Unlimited Twin": {
    downloadSpeed: "200",
    uploadSpeed: "200",
  },
  "Unlimited Pro": {
    downloadSpeed: "500",
    uploadSpeed: "200",
  },
  "Unlimited Edge": {
    downloadSpeed: "750",
    uploadSpeed: "250",
  },
  "Unlimited Turbo": {
    downloadSpeed: "1000",
    uploadSpeed: "300",
  },
  
  // Ultra Packages
  "Ultra Prime": {
    downloadSpeed: "1000",
    uploadSpeed: "500",
  },
  "Ultra Flash Prime": {
    downloadSpeed: "1000",
    uploadSpeed: "500",
  },
};

/**
 * Get speed string for a package
 * @param {string} packageName - The package name
 * @returns {string} Speed string in format "XXXMbps/YYYMbps" or "100Mbps/50Mbps" as default
 */
export const getPackageSpeed = (packageName) => {
  if (!packageName) {
    return "100Mbps/50Mbps";
  }
  
  const speed = packageSpeedMapping[packageName];
  if (speed) {
    return `${speed.downloadSpeed}Mbps/${speed.uploadSpeed}Mbps`;
  }
  
  // Default fallback speed
  return "100Mbps/50Mbps";
};

